import { ShieldAlert } from "lucide-react";

export function ValidationBanner({ className = "" }) {
  return (
    <div
      data-testid="validation-status-banner"
      className={`rounded-2xl border border-amber-200 bg-amber-50 p-5 flex items-start gap-3 ${className}`}
    >
      <ShieldAlert className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
      <p className="text-sm text-amber-800 leading-relaxed">
        <strong>Validation-ready, not validation-claimed.</strong> CareerStudy360 is built on established,
        peer-reviewed psychological frameworks, but it is its own independent instrument — not a branded clone of
        any single existing test. It is currently in a validation-ready stage: large-scale reliability, validity,
        norming and fairness studies are underway and will determine what, if anything, changes. Until then, treat
        every result here as a well-informed, guidance-grade starting point for exploration — not a final verdict.
      </p>
    </div>
  );
}
